module.exports = __webpack_public_path__ + "static/media/salmon.f270fe64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/salmon.jpg
// module id = 107
// module chunks = 0